export type OptimisedImageHost = {
  hostname: string;
  pathname: string;
};

export const OPTIMISED_IMAGE_HOSTS: OptimisedImageHost[] = [
  { hostname: "luckmedia.link", pathname: "/*/thumb_3_4_custom.jpg" },
  { hostname: "ik.imagekit.io", pathname: "/degaming/**" },
];

const matchesPathname = (pattern: string, pathname: string) => {
  const patternSegments = pattern.split("/");
  const pathSegments = pathname.split("/");

  for (let i = 0; i < patternSegments.length; i++) {
    const segment = patternSegments[i];
    if (segment === "**") return true;
    if (segment !== "*" && segment !== pathSegments[i]) return false;
  }

  return patternSegments.length === pathSegments.length;
};

export const isOptimisableImageUrl = (value: string) => {
  try {
    const url = new URL(value);

    return (
      url.protocol === "https:" &&
      OPTIMISED_IMAGE_HOSTS.some(
        (host) => host.hostname === url.hostname && matchesPathname(host.pathname, url.pathname),
      )
    );
  } catch {
    return false;
  }
};
